export const ACCOUNT_DETAILS_TABS_VALUE = {
  SUMMARY: "summary",
  HOMES: "homes",
  PRICING: "pricing",
  CONTACTS: "contacts",
  ADDER_BUCKETS: "adder-buckets",
  USERS: "users",
  SUPPRESSED_WORK: "suppressed-work",
};

export const ACCOUNT_PRICING_TABS_VALUE = {
  PRICE_AND_DISTRIBUTION: "Price & Distribution",
  PRICE_ASSIGNMENT: "Price Assignment",
};

export const SELECTED_PRICING_TABS = (isConfigured = true) => [
  {
    value: "Price & Distribution",
    label: ACCOUNT_PRICING_TABS_VALUE.PRICE_AND_DISTRIBUTION,
  },
  {
    value: "Price Assignment",
    label: ACCOUNT_PRICING_TABS_VALUE.PRICE_ASSIGNMENT,
    chipLabel: isConfigured ? "" : "!",
    chipColor: "warning",
  },
];

export const ACCOUNT_PRICING_VALUES = {
  LIST_PRICE: "ListPrice",
  COST: "Cost",
  DOLLAR: "Dollar",
  PERCENT: "Percent",
};

export const ACCOUNT_PRICING_DISPLAY_VALUES = {
  ListPrice: "List Price",
  Cost: "Cost",
  Dollar: "Dollar ($)",
  Percent: "Percent (%)",
};
